import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListPendingInvitationsParams } from 'src/app/core/seller-invitations.service';
import { UtilsService } from 'src/app/core/utils.service';
import {
  COMPANY_BUSINESS_NAME_FIELD_LABEL,
  COMPANY_ID_FIELD_LABEL,
  RECIPIENT_EMAIL_FIELD_LABEL,
  SENDER_EMAIL_FIELD_LABEL,
} from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-pending-invitations-filters',
  templateUrl: './pending-invitations-filters.component.html',
  styleUrls: ['./pending-invitations-filters.component.scss'],
})
export class PendingInvitationsFiltersComponent {
  @Input() filters?: ListPendingInvitationsParams;
  @Output() filter_clear: EventEmitter<ListPendingInvitationsParams> = new EventEmitter<ListPendingInvitationsParams>();

  constructor(private date_pipe: DatePipe, private utils_service: UtilsService) {}

  onFilterClear(key: string): void {
    if (this.filters) {
      this.filters[key as keyof typeof this.filters] = undefined;
      this.filter_clear.emit(this.filters);
    }
  }

  getFiltersKeys(): string[] {
    if (this.filters) {
      return Object.keys(this.filters).filter(k => {
        return this.isKeySet(k);
      });
    }
    return [];
  }

  isKeySet(key: string): boolean {
    if (!this.filters) return false;
    return this.utils_service.isFilterKeySet(this.filters, key);
  }

  getLabelByKey(key: string): string {
    switch (key) {
      case 'company_id':
        return COMPANY_ID_FIELD_LABEL;
      case 'recipient_email':
        return RECIPIENT_EMAIL_FIELD_LABEL;
      case 'company_business_name':
        return COMPANY_BUSINESS_NAME_FIELD_LABEL;
      case 'sender_email':
        return SENDER_EMAIL_FIELD_LABEL;
      default:
        return '';
    }
  }

  getContentByKey(key: string): string {
    switch (key) {
      case 'recipient_email':
        return this.filters?.recipient_email || '-';
      case 'company_id':
        return this.filters?.company_id || '-';
      case 'company_business_name':
        return this.filters?.company_business_name || '-';
      case 'sender_email':
        return this.filters?.sender_email || '-';

      default:
        return '';
    }
  }

  toStringDate(date: number): string {
    return this.date_pipe.transform(date, 'shortDate') || '-';
  }
}
